// extracted by mini-css-extract-plugin
export default {"container":"_2B8DdgsgoVVFUcknvSvdkS","label":"_3bVSZZUyw_EMYuLmoxegOi"};